import React from 'react'
import { listCustomers, inactivateCustomer, activateCustomer, deleteCustomer } from '../services/customerService'
import type { Customer, CustomerStats, CustomerStatus } from '../types'

export function useCustomers() {
  const [items, setItems] = React.useState<Customer[]>([])
  const [total, setTotal] = React.useState(0)
  const [page, setPage] = React.useState(1)
  const pageSize = 25
  const [search, setSearch] = React.useState('')
  const [status, setStatus] = React.useState<CustomerStatus | ''>('')
  const [planId, setPlanId] = React.useState<string | ''>('')
  const [loading, setLoading] = React.useState(false)
  const [error, setError] = React.useState<string | null>(null)
  const [stats, setStats] = React.useState<CustomerStats>({ total: 0, ativo: 0, pendente: 0, suspenso: 0, inativo: 0 })

  const load = React.useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const { items, total, stats } = await listCustomers({ search, page, pageSize, status, planId })
      setItems(items)
      setTotal(total)
      setStats(stats)
    } catch (e: any) {
      setError(e?.message ?? 'Falha ao carregar clientes')
    } finally { setLoading(false) }
  }, [search, page, status, planId])

  React.useEffect(() => { load() }, [load])

  return { items, total, page, setPage, pageSize, search, setSearch, status, setStatus, planId, setPlanId, loading, error, load, inactivateCustomer, activateCustomer, deleteCustomer, stats }
}

